import React from 'react';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Cell } from 'recharts';
import { getAscentTypeColor } from '@utils/gradeUtils.js';

const AscentTypesChart = ({ data, climbingStyle }) => {
  if (!data?.length) {
    return <div className="text-center py-8">No data available</div>;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="value" name="Ascents" fillOpacity={0.8}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={getAscentTypeColor(entry.name)} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AscentTypesChart;